import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    vehiculos: [],
  },

  getters: {
    getVehiculos: (state) => state.vehiculos,
  },

  mutations: {
    SET_VEHICULOS(state, vehiculos) {
      state.vehiculos = vehiculos;
    },
  },

  actions: {
    async fetchVehiculos({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/vehiculos`)
        .then((response) => {
          commit('SET_VEHICULOS', response.data.data);
        });
    },

    async saveVehiculo(_, vehiculos) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${vehiculos.fk_idPersonal}/vehiculos`, vehiculos);
    },

    async updateVehiculo(context, vehiculos) {
      await axios
        .put(`PoliciaCuadrantes/C3/personal/${vehiculos.fk_idPersonal}/vehiculos/${vehiculos.idVehiculo}`, vehiculos);

      context.dispatch('fetchVehiculos', vehiculos.fk_idPersonal);
    },
  },
};
